import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import indicatorsAction from "../../../../redux/actions/indicators";
import Header from "../../../Shared/Modals/Header";
import Content from "./Content";

export default function ViewGoalModal() {
  const dispatch = useDispatch();
  const { openExportData } = useSelector((state) => state.indicators);
  const app = useSelector((state) => state.app);
  const handleClose = () => {
    dispatch(indicatorsAction.toggleExportDataModal(false));
  };
  return (
    <Dialog
      open={openExportData}
      onClose={() => handleClose()}
      maxWidth="md"
      fullScreen={app.isMobile}
      scroll="body"
    >
      <DialogContent dividers>
        <Header handleClose={handleClose} title="Exportar metas" type="VIEW" />
        <Content />
      </DialogContent>
    </Dialog>
  );
}
